import { INeoAction } from './../Actions.interface';
import { SearchCustomer } from '../../Models/DTO/SearchCustomer.model';
import { ICustomerSimple } from '../../Models/DTO/Customer.model';
import { BOOKING_LIST_ACTIONS } from '../../Constants/Actions.constants';

type Customer = SearchCustomer | ICustomerSimple;

export default (state: Customer[] = [], action: INeoAction): Customer[] => {
  const { name, payload } = action;

  if (name === BOOKING_LIST_ACTIONS.SELECT_CUSTOMER) {
    const selectedIndex = state.findIndex((cust) => cust.id === payload.id);
    if (selectedIndex >= 0) {
      const mutate = [...state];
      mutate.splice(selectedIndex, 1);
      return mutate;
    } else {
      return [...state, payload];
    }
  }

  if (name === BOOKING_LIST_ACTIONS.CLEAR_SELECTED_CUSTOMERS) {
    return [];
  }

  return state;
};
